import { useEffect, useState } from "react";
import { useMutation } from "react-query";
import { useSelector } from "react-redux";
import LayoutWithoutDrawer from "../../../../layouts/LayoutWithoutDrawer";
import { IGetTotalCreditForAssetConvertResponse, ITotalCreditItems, TMortgageType } from "../../../../models/trade.model";
import { RootState } from "../../../../redux/store";
import { GetTotalCreditForAssetConvert } from "../../../../services/trade.service";
import { IInnerStateHomeMenu } from "../IHomeMenu";
import { ITrade } from "./ITrade";
import Trade from "./trade";
import TradeHistory from "./tradeHistory";
import TradeProfile from "./tradeProfile";


export default function TradeContainer({ setTabChild }: IInnerStateHomeMenu) {
    const [state, setState] = useState<ITrade>('tradeProfile');
    const [totalCreditForAsset, setTotalCreditForAsset] = useState<IGetTotalCreditForAssetConvertResponse>()
    const [selectedTotalCreditForAsset, setSelectedTotalCreditForAsset] = useState<ITotalCreditItems>()
    const [mortgageType, setMortgageType] = useState<TMortgageType>();
    const stateFromRedux = useSelector((state: RootState) => state.prevAndNextState.nextInnerState);
    const { mutate: GetTotalCreditForAssetConvertMutate, isLoading: GetTotalCreditForAssetConvertLoading } = useMutation(
        GetTotalCreditForAssetConvert,
        {
            onSuccess: (data: IGetTotalCreditForAssetConvertResponse) => {
                if (data) {
                    setTotalCreditForAsset(data)
                }
            },

            onError: () => { },
        }
    );

    useEffect(() => {
        setSelectedTotalCreditForAsset(totalCreditForAsset?.totalCreditItems.find((item) => item.mortgageType === mortgageType))
    }, [mortgageType, totalCreditForAsset])

    useEffect(() => {
        GetTotalCreditForAssetConvertMutate()
        if (stateFromRedux.includes('tradeProfile')) {
            setState('tradeProfile')
        }
    }, [stateFromRedux])

    const innerStep = {
        'tradeProfile': <TradeProfile setState={setState} promotionItems={totalCreditForAsset?.promotionItems} totalCreditForAsset={totalCreditForAsset?.totalCreditItems} setMortgageType={setMortgageType} setTabChild={setTabChild} GetTotalCreditForAssetConvertLoading={GetTotalCreditForAssetConvertLoading} />,
        'trade': <Trade setState={setState} selectedTotalCreditForAsset={selectedTotalCreditForAsset} />,
        'tradeHistory': <TradeHistory />,
    }

    return (
        <LayoutWithoutDrawer>
            {innerStep[state!]}
        </LayoutWithoutDrawer>
    )
}
